module.exports = __webpack_public_path__ + "img/locked.77965673.svg";